const authInitState = {
    auth: false,
    auth_err: 'false'
}

function AuthR (state = authInitState, action) {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, auth: true, loginErr: false }
    case 'SIGNUP_ERR':
      return { ...state, auth_err: "Sign up failed" }
    case 'LOGIN_ERR':
      return { ...state, auth_err: "Login failed", loginErr: true }
    case 'LOGOUT':
      return { ...state, auth: false }
    case 'GET_TOKEN':
      return {
        ...state,
        auth: action.auth,
        username: action.username,
        userType: action.userType,
        userId: action.userId,
        levelType: action.levelType
      }
    default:
      return state
  }
}

export default AuthR
